module.exports = __webpack_public_path__ + "img/template02.b13c5589.png";